import type { FormFields } from './formTypes';

export type AutoshipFrequencySelection = Pick<FormFields, 'autoshipFrequency' | 'autoshipUnit'>;

const customerFrequencyBySku = new Map<string, AutoshipFrequencySelection>();

export const getCustomerFrequencySelection = (sku?: string): AutoshipFrequencySelection | null => {
    if (!sku) return null;
    return customerFrequencyBySku.get(sku) ?? null;
};

export const saveCustomerFrequencySelection = (sku: string, selection: AutoshipFrequencySelection): void => {
    customerFrequencyBySku.set(sku, selection);
};

export const clearCustomerFrequencySelections = (): void => {
    customerFrequencyBySku.clear();
};
